import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { ConstantsService } from '../../services/constants.service';
import { SavedSearchService } from '../../services/saved-search.service';

@Component({
  selector: 'app-search-load-dialog',
  templateUrl: './search-load-dialog.component.html',
  styleUrls: ['./search-load-dialog.component.css']
})
export class SearchLoadDialogComponent {
  @ViewChild('fileUpload') fileupload?: FileUpload;
  @Input() loadSearchVisible: boolean = false;
  @Output() loadSearch = new EventEmitter();
  @Output() closeLoadSearch = new EventEmitter();

  selectedFile: File | null = null;
  fileContent: string | null = null;
  processedData: any;
  loadError: boolean = false;

  constructor(private saveSearchSvc: SavedSearchService, private messageSvc:MessageService, private constants: ConstantsService) {

  }

  onFileSelect(event: any) {
    this.selectedFile = event.files[0];
    this.loadError = false;
    // this.executeLoadSearch();
    // console.log('file: ' + this.selectedFile?.name);
  }

  onClearFile(event:any){
    console.log("cleared");
    this.selectedFile = null;
    this.loadError = false;
  }

  executeClose() {
    this.closeLoadSearch.emit();
  }

  executeLoadSearch() {
    if (this.selectedFile) {
      const reader = new FileReader();
      reader.onload = (e:any) => {
        this.fileContent = e.target.result;
        this.processFileContent();
      };
      reader.readAsText(this.selectedFile);
    }
  }


  processFileContent() {
    if (this.fileContent) {
      try {
        this.processedData = this.saveSearchSvc.decode(this.fileContent);
        this.loadError = false;
        // console.log('fc: ' + this.fileContent);
        // console.log("pd: " + JSON.stringify(this.processedData));
        if(this.fileupload){
          this.fileupload.clear();
        }
        this.loadError = false;
        this.loadSearch.emit(this.processedData);
      }
      catch (error) {
        this.loadError = true;
        this.messageSvc.add({ severity: 'danger', summary: 'Load Error!', detail: 'Error loading search file!', key: 'loadSearch' });
      }
    }
  }
}
